import { useLocation } from '@gatsbyjs/reach-router'
import React, { useEffect, useMemo, useState } from 'react'
import { contextMenu } from '.'
import { DesktopMenu } from './DesktopMenu'
import { MobileMenu } from './MobileMenu'

export const MenuComponent = () => {
  const [openNav, setOpenNav] = useState(false)
  const location = useLocation()

  useEffect(() => {
    window.addEventListener(
      'resize',
      () => window.innerWidth >= 960 && setOpenNav(false),
    )
  }, [])

  const isCommercialLanding = location?.pathname === '/je-suis-un-cabinet'

  const getAccountLink = useMemo(() => {
    if (isCommercialLanding) {
      return 'https://lamadash.fr/signup_login'
    }
    return 'https://lamadash.fr/signup_login_candidat'
  }, [isCommercialLanding])

  const menuItems = useMemo(
    () => {
      if (isCommercialLanding) {
        return contextMenu.find(item => item.value === 'firm')?.links || []
      }
      return contextMenu.find(item => item.value === 'candidate')?.links || []
    },
    [],
  )

  return (
    <nav
      id="navbar"
      data-testid="MegaMenuWithHover"
      role="navigation"
      className="sticky top-0 z-10 block w-full px-2 bg-white py-1.5 md:px-4 lg:px-0"
    >
      <DesktopMenu
        menuItems={menuItems}
        getAccountLink={getAccountLink}
        isCommercialLanding={isCommercialLanding}
      />
      <MobileMenu
        menuItems={menuItems}
        getAccountLink={getAccountLink}
        openNav={openNav}
        setOpenNav={setOpenNav}
        isCommercialLanding={isCommercialLanding}
      />
    </nav>
  )
}
